package com.eladfinish.bible.contest.screens.mikud.ui.dialogs

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogPositiveButtonInColumn
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar

@Composable
fun SimpleMessageDialog(
    onDismiss: () -> Unit,
    title: String,
    content: String,
) {
    BasicDialogWithTitle(
        onDismiss = onDismiss,
        title = title,
        content = {
            Column(
                modifier = Modifier
                    .weight(1f)
                    .background(Color.White)
                    .fillMaxWidth()
                    .verticalScrollWithScrollbar(),
            ) {
                SelectionContainer {
                    Text(
                        modifier = Modifier
                            .padding(top = 12.dp, bottom = 24.dp)
                            .padding(horizontal = 12.dp),
                        text = content,
                        style = MaterialTheme.typography.bodyLarge.copy(
                            fontSize = 18.sp
                        ),
                    )
                }
            }
            DialogPositiveButtonInColumn(onClick = onDismiss)
        }
    )
}
